<section
  class="rounded-2xl rounded-t-none border border-neutral-200 bg-white p-4 shadow-sm
         dark:border-neutral-800 dark:bg-neutral-800
         flex flex-col
h-auto
"
>
  <!-- Header com botão -->
  <div class="flex items-center justify-between mb-4">
    <span class="text-[11px] font-extrabold uppercase tracking-wider text-neutral-700 dark:text-neutral-400">
      Timeline do pedido
    </span>
    <button
      type="button"
      (click)="openFullTimeline()"
      class="inline-flex items-center gap-1.5 rounded-lg border bg-white px-3 py-1.5
             text-xs font-medium shadow-sm transition-all duration-300
             dark:bg-neutral-700 dark:text-neutral-200"
      [disabled]="fullTimelineLoading()"
      [title]="fullTimelineLoading() ? 'Carregando detalhes da linha do tempo...' : ''"
      [ngClass]="{
        'border-neutral-200 text-neutral-700 hover:bg-neutral-50 hover:border-neutral-300 dark:border-neutral-600 dark:hover:bg-neutral-600 dark:hover:border-neutral-500 cursor-pointer': !fullTimelineLoading(),
        'border-blue-300 text-blue-600 dark:border-blue-500 dark:text-blue-400 cursor-wait opacity-80': fullTimelineLoading()
      }"
    >
      @if (fullTimelineLoading()) {
        <svg class="h-3.5 w-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      } @else {
        <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      }
      Ver detalhes da linha do tempo
    </button>
  </div>

  <!-- Skeleton loading -->
  <div *ngIf="timelineLoading" class="flex-1 pr-2">
    <div class="flex flex-col gap-4 animate-pulse">
      <div *ngFor="let _ of [1, 2, 3, 4]" class="flex items-center gap-6">
        <div class="shrink-0">
          <span class="block h-4 w-4 rounded-full bg-neutral-200 dark:bg-neutral-700"></span>
        </div>
        <div class="flex-1 rounded-md bg-neutral-100 dark:bg-neutral-700 h-12"></div>
      </div>
    </div>
  </div>

  <!-- Conteúdo com overflow -->
  <div *ngIf="!timelineLoading" class="flex-1 pr-2">
    <div class="flex flex-col gap-4">
      <ng-container *ngFor="let item of timelineItems(); let i = index; let last = last">
        <div class="flex items-center gap-6 relative">

          <!-- Coluna da timeline -->
          <div class="relative flex flex-col items-center shrink-0">

            <!-- Linha superior -->
            <span
              *ngIf="i !== 0"
              class="absolute top-0 h-1/2 w-px bg-neutral-300 dark:bg-neutral-700"
            ></span>

            <!-- Linha inferior -->
            <span
              *ngIf="!last"
              class="absolute bottom-0 h-1/2 w-px bg-neutral-300 dark:bg-neutral-700"
            ></span>

            <!-- Bolinha -->
            <span
              class="z-10 h-4 w-4 rounded-full border-2"
              [ngClass]="{
                'bg-green-500 border-green-500':
                  item.status === 'completed' ||
                  item.status === 'completed-last',

                'bg-yellow-500 border-yellow-500':
                  item.status === 'pending-current',

                'bg-neutral-300 border-neutral-300 dark:bg-neutral-600 dark:border-neutral-600':
                  item.status === 'pending-future',

                'bg-red-600 border-red-600':
                  item.status === 'pending-error'
              }"
            ></span>
          </div>

          <!-- Card do evento (cores preservadas) -->
          <div
            class="flex-1 rounded-md border border-neutral-200 bg-white p-3
                   dark:border-neutral-700 dark:bg-neutral-800"
          >
            <div class="flex items-start justify-between gap-4">

              <div class="flex items-center gap-2 flex-wrap">
                <!-- Origem → destino -->
                <span
                  class="rounded-full border px-2 py-0.5 text-[11px] uppercase tracking-wide
                         bg-white/60 border-neutral-300 text-neutral-700
                         dark:bg-neutral-900/40 dark:border-neutral-600 dark:text-neutral-300"
                >
                  {{ item.systemOrigin }} → {{ item.systemTarget }}
                </span>

                <!-- Nome -->
                <span class="text-sm font-semibold text-neutral-900 dark:text-white">
                  {{ statusLabel(item.statusDescription) }}
                </span>
              </div>

              <!-- transferredAt -->
              @if (item.transferredAt) {
                <span class="text-[11px] text-neutral-500 whitespace-nowrap
                       dark:text-neutral-400"
                      title="Transferido em"
                >
                  {{ item.transferredAt | date: 'dd/MM/yyyy HH:mm' }}
                </span>
              }
            </div>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</section>

<app-modal #fullTimelineModal title="Timeline Completo">
  <div class="w-[1000px] max-w-[calc(100vw-4rem)]">
    <app-order-full-timeline
      [loading]="fullTimelineLoading()"
      [error]="fullTimelineError()"
      [data]="fullTimelineData()"
    />
  </div>
</app-modal>
